import * as types from './mutation-types'
import { webService, apiActions } from '../api'
import rGen from '../gadgets/randomIdGen'
import { CrossStorageClient } from './../cross'
// eslint-disable-next-line node/no-deprecated-api
// import { encodeUrl } from 'punycode'
// const $wx = require('../assets/vendors/jweixin-1.4.0.js')
const co = require('co')
const $wx = window.wx

// test
const browser = {
  versions: (function () {
    var u = navigator.userAgent
    // var app = navigator.appVersion
    return { // 移动终端浏览器版本信息
      IE: u.indexOf('MSIE') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      weChat: !!u.match(/MicroMessenger/i), // 是否微信
      aliPay: !!u.match(/Alipay/i) // 是否支付宝
    }
  }()),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
const actions = {
  VERIFY_TOKEN ({ commit, dispatch, state }, redirectUrl) {
    return new Promise((resolve, reject) => {
      let params = { accessToken: state.sdk.accessToken }
      dispatch('validateToken', { params }).then(data => {
        resolve(true)
      }).catch(msg => {
        dispatch('GO_TO_LOGIN_NOT_APP', redirectUrl)
        reject(msg)
      })
    })
  },
  /**
   *非app 联登获取token 流程-获取，登出，设置token
   *
   * @param {*} {commit, dispatch, state}
   * @returns
   */
  GET_ACCESS_TOKEN_NOT_APP ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      const URL = getConnectUrl()
      let storage = new CrossStorageClient(URL)
      storage.onConnect()
        .then(function () {
          return storage.get('access_token')
        }).then((res) => {
          actions.setSdkData({ commit, dispatch, state }, { accessToken: res })
          // alert(res + 'success')
          if (!res || res === 'null') {
            commit('CONNECT_TOKEN_FAIL')
            reject(res)
          }
          resolve(res)
        }).catch((err) => {
          // alert(err + 'error')
          console.log(err)
          commit('CONNECT_TOKEN_FAIL')
          reject(err)
        })
    })
  },
  GO_TO_LOGIN_NOT_APP ({ dispatch, commit, state }, redirectUrl = location.href) {
    // TODO 每次发版需更改版本号，传递至登录页
    if (window.__wxjs_environment === 'miniprogram') {
      // 微信小程序调起原生登录页
      // 清accessToken
      // actions.setSdkData({ commit, dispatch, state }, { accessToken: '' })
      commit('CLEAR_ACCESS_TOKEN')
      dispatch('SET_ACCESS_TOKEN', '')
      // alert('action:' + state.sdk.accessToken)
      if (redirectUrl.indexOf('access_token') >= 0) {
        let oArry = redirectUrl.split('?')[1].split('&')
        let delIndex = oArry.findIndex(item => (item.indexOf('access_token') >= 0))
        oArry.splice(delIndex, 1)
        redirectUrl = redirectUrl.split('?')[0] + '?' + oArry.join('&')
      }
      $wx.miniProgram.redirectTo({ url: `/subPackages/login/login?webViewRedirectUrl=${encodeURIComponent(redirectUrl)}&webviewLogin=1&fromH5=1` })
      return
    }
    // 公共登录页
    const URL = getConnectUrl()
    let params = {}
    if (redirectUrl) {
      params.redirect_url = redirectUrl
      params.version = state.version
      if (redirectUrl.indexOf('transferPage') !== -1) {
        // 如果是从中转页跳转到统一登录页,在图形验证码的跳转url上加参数mode=2
        params.capchaBackMode = 2
      }
    }
    if (state.connectTokenFail) {
      params.type = 'params'
      const redirect = redirectUrl || location.href
      params.redirect_url = redirect
    }
    if (params.redirect_url) {
      params.redirect_url = encodeURIComponent(deleteQueryFromUrlHash(params.redirect_url, 'access_token'))
    }
    const paramsArr = Object.keys(params).map(key => `${key}=${params[key]}`)
    window.location.href = `${URL}?${paramsArr.join('&')}`
  },
  SET_ACCESS_TOKEN ({ dispatch, commit, state }, token) {
    return new Promise((resolve, reject) => {
      const URL = getConnectUrl()
      let storage = new CrossStorageClient(URL)
      storage.onConnect()
        .then(() => {
          return storage.set('access_token', token)
        }).then(res => {
          resolve(res)
        }).catch(err => {
          commit('CONNECT_TOKEN_FAIL')
          reject(err)
        })
    })
  },
  LOGOUT ({ dispatch, commit, state }) {
    return new Promise(async (resolve, reject) => {
      try { await dispatch('SET_ACCESS_TOKEN', '') } catch (e) { console.log(e) }
      dispatch('GO_TO_LOGIN_NOT_APP')
      resolve()
    })
  },
  /**
   *  闪付订单获取店铺优惠券
   */
  FECTH_QUICK_COUPON_LIST ({ commit, dispatch, state }, { playLoadCoupon }) {
    commit('SET_QUICK_COUPON_LIST', { playLoadCoupon })
    const quickCoupon = playLoadCoupon[0]
    commit('SET_QUICK_COUPON', { quickCoupon })
  },
  /**
   * 确认订单初始化时，修改返回接口数据，增加默认选中优惠券对象字段
   * @param {*String} playLoad 为接口数据, tempPriceObj是单个优惠券对象，也可是单商铺不用优惠券的总价-字符类型
   */
  FECTH_CONFIRM_ORDER_DETAIL ({ commit, dispatch, state }, { playLoad }) {
    const arr = playLoad.map(storeItem => {
      if (storeItem.cardCouponRecordList && storeItem.cardCouponRecordList.length > 0) {
        return {
          tempPriceObj: storeItem.cardCouponRecordList[0],
          ...storeItem
        }
      } else {
        return {
          tempPriceObj: {
            tempPrice: storeItem.totalAmount
          },
          ...storeItem
        }
      }
    })

    // console.log(arr, 'FECTH_CONFIRM_ORDER_DETAIL')
    commit('SET_CONFIRM_ORDER_DETAIL', { arr })
  },

  /**
   * 优惠券列表，点击选中时，替换单个店铺中默认优惠券信息
   * @param {*String} playLoad
   */
  MODIFI_CONFIRM_ORDER_DETAIL ({ commit, dispatch, state }, { playLoad }) {
    const storeIndex = playLoad.storeIndex
    if (!playLoad.couponItem.id) {
      const tempPrice = state.confirmOrderDetail[storeIndex].totalAmount
      const couponItem = playLoad.couponItem
      state.confirmOrderDetail[storeIndex].tempPriceObj = { tempPrice, ...couponItem }
    } else {
      state.confirmOrderDetail[storeIndex].tempPriceObj = playLoad.couponItem
    }
  },

  /**
  * 初始化接口状态标识
  * @param {*} param0
  * @param {*String} apiAction 接口对应action的名称
  */
  initToggle ({ commit, dispatch, state }, apiAction) {
    commit(types.SET_API_TOGGLE_INIT, { apiAction })
  },
  /**
   *
   *
   * @param {*} { dispatch, commit }
   * @returns
   */
  GET_CLIENT_ID ({ dispatch, commit }) {
    if (sessionStorage.clientId) {
      const clientId = sessionStorage.clientId
      commit('SET_CLIENT_ID', clientId)
      return Promise.resolve(clientId)
    } else { // Or just set it
      const clientId = rGen(16)
      sessionStorage.setItem('clientId', clientId)
      commit('SET_CLIENT_ID', clientId)
      return Promise.resolve(clientId)
    }
  },
  /**
   * 设置关于app sdk的数据
   * @param {*} param0
   * @param {*Object} obj 需要存放在store.state.sdk里面的任意对象
   */
  setSdkData ({ commit, dispatch, state }, obj) {
    commit(types.SET_SDK_DATA, obj)
  },
  /**
   * 设置用户信息
   * @param {*} param0
   * @param {*Object} obj 需要存放在store.state.userInfo里面的任意对象
   */
  setUserInfo ({ commit, dispatch, state }, obj) {
    commit(types.SET_USER_INFO, obj)
  },

  setCommunityInfo ({ commit, dispatch, state }, obj) {
    commit(types.SET_COMMUNITY_INFO, obj)
  },
  /**
   * 设置服务信息
   * @param {*} param0
   * @param {*Object} obj 需要存放在store.state.serviceInfo
   */
  setServiceInfo ({ commit, dispatch, state }, obj) {
    commit(types.SET_SERVICE_INFO, obj)
  },
  /**
   * 设置store信息
   * @param {*} param0
   * @param {*Object} obj 需要存放在store.state.serviceInfo
   */
  setStoreInfo ({ commit, dispatch, state }, obj) {
    commit(types.SET_STORE_INFO, obj)
  },
  /**
   * 弹窗开关
   * @param {*} param0
   * @param {*{name:String,visible:Boolean}} param1 弹窗名称 和 显示状态
   */
  dialogVisible ({ commit, dispatch, state }, { name, visible }) {
    commit(types.SET_DIALOG_VISIBLE, { name, visible })
  },
  initTrolley ({ commit, dispatch, state }) {
    commit(types.INIT_TROLLEY)
  },
  syncTrolley ({ commit, dispatch, state }, product) {
    commit(types.SET_TROLLEY, { product })
  },
  /**
   * 判断app sdk是否注入
   * @param {*} param0
   * @param {*} param1
   */
  onSdkReady ({ commit, dispatch, state }, { times = 30, delay = 100 } = {}) {
    // 旧版APP 判断 猎德桥 是否能用，4.0为强升版本，意味此方法已废弃
    let apiAction = 'onSdkReady'
    commit(types.SET_API_TOGGLE_LOADING, { apiAction })
    return new Promise((resolve, reject) => {
      co(function * () {
        for (let i = 0; !window.RFBridge; i++) {
          // var now = Date.now();
          if (i >= times) {
            throw new Error('注入超时')
          }
          yield function (cb) {
            setTimeout(cb, delay)
          }
        }
      }).then(data => {
        actions.setSdkData({ commit, dispatch, state }, { isApp: true })
        commit(types.SET_API_TOGGLE_SUCCESS, { apiAction })
        resolve('注入成功')
      }).catch(reason => {
        actions.setSdkData({ commit, dispatch, state }, { isApp: false })
        commit(types.SET_API_TOGGLE_FAIL, { apiAction })
        reject(reason)
      })
    })
  },

  /**
   *  拉起地图
   *
   *  @param address 地址字符串
   *  @param coordinates 经纬度数组字符串化： JSON.stringify([{lat, lon}]) lat, lon 均为字符
   */

  openMap ({ commit, dispatch, state }, { name, address, coordinates } = {}) {
    // alert(JSON.stringify(Object.keys(window.RFBridge)))
    return new Promise((resolve, reject) => {
      try {
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_OpenMapWithNameAddressCoordinates(name, address, coordinates)
            resolve()
          }, 500)
        } else {
          window.RFBridge.RFN_OpenMapWithNameAddressCoordinates(name, address, coordinates)
          // Toast.info(JSON.stringify('ios'))
          resolve()
        }
      } catch (error) {
        // alert(JSON.stringify(error))
        reject(error)
      }
    })
  },

  getCommunityId ({ commit, dispatch, state }) {
    // App的猎德桥 获取communityId
    return new Promise((resolve, reject) => {
      try {
        window.__onGetCommunityID = function (error, communityID) {
          if (error) {
            // alert("__onGetCommunityID error:" + JSON.stringify(error));
            reject(error)
          } else {
            // alert("__onGetCommunityID communityID:" + JSON.stringify(communityID));
            sessionStorage.setItem('communityId', communityID)
            actions.setSdkData({ commit, dispatch, state }, { communityId: communityID })
            resolve(communityID)
          }
        }
        // alert("RFN_GetCommunityIDWithCallbackFunctionName");

        if (browser.versions.android) {
          // android 慢
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_GetCommunityIDWithCallbackFunctionName('__onGetCommunityID')
          }, 1000)
        } else {
          window.RFBridge.RFN_GetCommunityIDWithCallbackFunctionName('__onGetCommunityID')
        }
        // window.RFBridge.RFN_GetCommunityIDWithCallbackFunctionName('__onGetCommunityID');
      } catch (error) {
        reject(error)
      }
    })
  },
  collectApp ({ commit, dispatch, state }, { activityId, type }) {
    // APP内收藏功能 第一个参数活动ID，第二个参数1表示社区的活动，2表示生活的活动
    return new Promise((resolve, reject) => {
      try {
        if (window.RFBridge) {
          window.RFBridge.RFN_enableFavorWithIdAndCategory(activityId, type)
        } else {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_enableFavorWithIdAndCategory(activityId, type)
          }, 1000)
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  getAppPic ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      try {
        window.__onGetPhotoSuccess = async (error, data) => {
          if (error) {
            reject(error)
          } else {
            resolve(data)
          }
        }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_GetUserPhotoMaxCallbackFunctionName(1, '__onGetPhotoSuccess')
          }, 1000)
        } else {
          window.RFBridge.RFN_GetUserPhotoMaxCallbackFunctionName(1, '__onGetPhotoSuccess')
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  getThirdPartyService ({ commit, dispatch, state }, { serviceId, type }) {
    // serviceId(类型字符)是服务ID，type = 3表示第三方服务(类型字符)
    return new Promise((resolve, reject) => {
      try {
        // if (window.RFBridge) {
        //   window.RFBridge.RFN_OpenServiceWithIdServiceTypeCommunityAndFilter(serviceId, type)
        //   resolve(window.RFBridge)
        // } else {
        //   let timer = setTimeout(function () {
        //     clearTimeout(timer)
        //     window.RFBridge.RFN_OpenServiceWithIdServiceTypeCommunityAndFilter(serviceId, type)
        //     resolve(window.RFBridge)
        //   }, 1000)
        // }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            // alert(JSON.stringify('android after'))
            window.RFBridge.RFN_OpenServiceWithIdServiceTypeCommunityAndFilter(serviceId, type, '', '')
            clearTimeout(timer)
          }, 1000)
        } else {
          // alert(JSON.stringify('ios before'))
          window.RFBridge.RFN_OpenServiceWithIdServiceTypeCommunityAndFilter(serviceId, type, '', '')
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  /**
   *  分享链接到社交网络，所有参数必须为字符串
   *  @param title 分享的标题
   *  @param desc 分享的描述
   *  @param thumbnail 分享的缩略图URL
   *  @param link 分享的链接
   *  @param wechatFrdTitle 朋友圈分享的标题
   *  @param callbackFunc 回调函数, callbackFunc(param1, param2, param3) 接收两个参数，param1:是否出错 error\null
   *  param2:状态 'click'\'success'\'cancel' 点击，成功，取消
   *  param3: 渠道 InApp\WeChatFrd\WeChatTimeline\Weibo\QQFrd\CopyLink
   */
  shareApp ({ commit, dispatch, state }, { title, desc, thumbnail, link, wechatFrdTitle, type, channel }) {
    // alter(title, 'title')
    // alter(desc, 'desc')
    // alter(thumbnail, 'thumbnail')
    // alter(link, 'link')
    return new Promise((resolve, reject) => {
      try {
        window.__onShareApp = function (error, type, channel) {
          if (error) {
            reject(error)
          } else {
            // 数果，百度统计
            window._hmt.push(['_trackEvent', 'app分享', type, channel])
            resolve(type, channel)
          }
        }
        if (window.RFBridge) {
          window.RFBridge.RFN_SocialShareWithTitleDescThumbnailLinkWechatTitleCallbackFunctionName(title, desc, thumbnail, link, wechatFrdTitle, '__onShareApp')
        } else {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_SocialShareWithTitleDescThumbnailLinkWechatTitleCallbackFunctionName(title, desc, thumbnail, link, wechatFrdTitle, '__onShareApp')
          }, 1000)
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  /**
   *  指定渠道分享链接到社交网络，所有参数必须为字符串
   *  @param title 分享的标题
   *  @param desc 分享的描述
   *  @param thumbnail 分享的缩略图URL
   *  @param link 分享的链接
   *  @param wechatFrdTitle 朋友圈分享的标题
   *  @param channel 分享渠道 穿字符串 0:WeChatFrd 1:WeChatTimeline 2:Weibo 3:QQFrd 4:CopyLink
   *  @param callbackFunc 回调函数, callbackFunc(param1, param2, param3) 接收两个参数，param1:是否出错 error\null
   *  param2:状态 'click'\'success'\'cancel' 点击，成功，取消
   *  param3: 渠道 InApp\WeChatFrd\WeChatTimeline\Weibo\QQFrd\CopyLink
   */
  directShareApp ({ commit, dispatch, state }, { title, desc, thumbnail, link, wechatFrdTitle, shareChannel, type, channel }) {
    return new Promise((resolve, reject) => {
      try {
        window.__onShareApp = function (error, type, channel) {
          if (error) {
            reject(error)
          } else {
            // 数果，百度统计
            window._hmt.push(['_trackEvent', 'app分享', type, channel])
            resolve(type, channel)
          }
        }
        if (window.RFBridge) {
          window.RFBridge.RFN_DirectSocialShareWithTitleDescThumbnailLinkWechatTitleChannelCallbackFunctionName(title, desc, thumbnail, link, wechatFrdTitle, shareChannel, '__onShareApp')
        } else {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_DirectSocialShareWithTitleDescThumbnailLinkWechatTitleChannelCallbackFunctionName(title, desc, thumbnail, link, wechatFrdTitle, shareChannel, '__onShareApp')
          }, 1000)
        }
      } catch (error) {
        reject(error)
      }
    })
  },

  checkIfLogin ({ commit, dispatch, state }) {
    // 新APP 猎德桥
    return new Promise((resolve, reject) => {
      try {
        window.__onCheckLogin = function (error, accessToken) {
          if (error) {
            // window.location.href="about:blank"
            // alert("__onCheckLogin error:" + JSON.stringify(error));
            reject(error)
          } else {
            // alert("__onCheckLogin accessToken99:" + JSON.stringify(accessToken));
            if (!accessToken.accessToken) {
              // alert("__onCheckLogin accessToken:" + JSON.stringify(accessToken));
              reject(new Error('没有accessToken'))
              return
            }
            actions.setSdkData({ commit, dispatch, state }, { accessToken: accessToken.accessToken })
            resolve(accessToken)
          }
        }
        if (browser.versions.android) {
          // android 慢
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_LoginWithCallbackFunctionName('__onCheckLogin')
          }, 1000)
        } else {
          window.RFBridge.RFN_LoginWithCallbackFunctionName('__onCheckLogin')
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  /**
   * 打开app原生页面(available 4.11)
   * @param {*} param0
   * @param {*} pageName
   */
  openAppPage ({ commit, dispatch, state }, pageName) {
    return new Promise((resolve, reject) => {
      try {
        window.RFBridge.RFN_OpenNativePageWithName(pageName)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },
  getLatiAndLong ({ commit, dispatch, state }) {
    // 获取APP 用户经纬度，但项目中无使用
    return new Promise((resolve, reject) => {
      try {
        window.__onGetLatiAndLong = function (error, info) {
          // alert("__onGetOpenUid info:" + JSON.stringify(info));
          if (error) {
            reject(error)
          } else {
            let data = info
            if (typeof info === 'string') {
              data = JSON.parse(info)
            }
            actions.setSdkData({ commit, dispatch, state }, { lat: data.lat, lng: data.lng })// save
            resolve(data)
          }
        }
        // alert("RFN_GetGPSWithCallbackFunctionName clientTicket:"+clientTicket);
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_GetGPSWithCallbackFunctionName('__onGetLatiAndLong')
          }, 1000)
        } else {
          window.RFBridge.RFN_GetGPSWithCallbackFunctionName('__onGetLatiAndLong')
        }
        // window.RFBridge.RFN_GetGPSWithCallbackFunctionName(clientTicket, '__onGetOpenUid');
      } catch (error) {
        reject(error)
      }
    })
  },
  getOpenId ({ commit, dispatch, state }, { clientTicket }) {
    // 旧版APP 获取accessToken 一部分，已废弃
    return new Promise((resolve, reject) => {
      try {
        window.__onGetOpenUid = function (error, info) {
          // alert("__onGetOpenUid info:" + JSON.stringify(info));
          if (error) {
            // alert("__onGetOpenUid error:" + JSON.stringify(error));
            reject(error)
          } else {
            let data = info
            // alert('__onGetOpenUid info:' + JSON.stringify(info))
            if (typeof info === 'string') {
              data = JSON.parse(info)
            }
            actions.setSdkData({ commit, dispatch, state }, { openId: data.open_id })// save
            resolve(data)
          }
        }
        // alert("RFN_GetOpenUIDWithTicketCallbackFunctionName clientTicket:"+clientTicket);
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_GetOpenUIDWithTicketCallbackFunctionName(clientTicket, '__onGetOpenUid')
          }, 1000)
        } else {
          window.RFBridge.RFN_GetOpenUIDWithTicketCallbackFunctionName(clientTicket, '__onGetOpenUid')
        }
        // window.RFBridge.RFN_GetOpenUIDWithTicketCallbackFunctionName(clientTicket, '__onGetOpenUid');
      } catch (error) {
        reject(error)
      }
    })
  },
  payOrder ({ commit, dispatch, state }, { openId, outTradeNo, communityTradeNo }) {
    // 无论新旧APP 都调用 支付猎德桥
    return new Promise((resolve, reject) => {
      try {
        window.__onPayFinish = function (error) {
          if (error) {
            reject(error)
          } else {
            resolve('success')
          }
        }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_PayOrderWithOpenIDOutTradeNOCommunityTradeNOCallbackFunctionName(openId, outTradeNo, communityTradeNo, '__onPayFinish')
          }, 500)
        } else {
          window.RFBridge.RFN_PayOrderWithOpenIDOutTradeNOCommunityTradeNOCallbackFunctionName(openId, outTradeNo, communityTradeNo, '__onPayFinish')
        }
        // window.RFBridge.RFN_PayOrderWithOpenIDOutTradeNOCommunityTradeNOCallbackFunctionName(openId, outTradeNo, communityTradeNo,'__onPayFinish');
      } catch (error) {
        reject(error)
      }
    })
  },
  getAppVersion ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      try {
        window.__onGetAppVersion = function (error, version) {
          if (error) {
            reject(error)
          } else {
            // 三段式：4.10.1
            resolve(version)
          }
        }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_GetAppVersionWithCallbackFunctionName('__onGetAppVersion')
          }, 500)
        } else {
          window.RFBridge.RFN_GetAppVersionWithCallbackFunctionName('__onGetAppVersion')
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  /**
   * App环境上跳转小程序支付
   * @param {*} param0
   * @param {{miniProgramID: 小程序ID, path: 小程序访问路径, type: 0正式版||1开发版||2体验版}} param1
   */
  payWithMiniPro ({ commit, dispatch, state }, { miniProgramID, path, type }) {
    return new Promise((resolve, reject) => {
      try {
        window.__onMiniProgramFinishPay = function (error, res) {
          if (error) {
            reject(error)
          } else {
            resolve(res)
          }
        }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_pageWillDisappear() // 安卓专用，离开webview时上报
            window.RFBridge.RFN_payWithMiniProgramIDPathTypeCallbackFunctionName(miniProgramID, path, type, '__onMiniProgramFinishPay')
          }, 500)
        } else {
          window.RFBridge.RFN_payWithMiniProgramIDPathTypeCallbackFunctionName(miniProgramID, path, type, '__onMiniProgramFinishPay')
        }
      } catch (error) {
        reject(error)
      }
    })
  },

  /**
   * App环境上通联银行卡支付
   * @param {*} param0
   * @param {{jsonString: SDK所需的参数}} param1
   */
  payWithCreditCard ({ commit, dispatch, state }, { jsonString }) {
    return new Promise((resolve, reject) => {
      try {
        window.__onCreditCardFinishPay = function (error, res) {
          if (error) {
            console.log('__onCreditCardPayError :>>', error, res)
            reject(res)
          } else {
            console.log('__onCreditCardFinishPay :>>', res)
            resolve(res)
          }
        }
        if (browser.versions.android) {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_pageWillDisappear() // 安卓专用，离开webview时上报
            window.RFBridge.RFN_payWithUnionStringCallbackFunctionName(jsonString, '__onCreditCardFinishPay')
          }, 500)
        } else {
          window.RFBridge.RFN_payWithUnionStringCallbackFunctionName(jsonString, '__onCreditCardFinishPay')
        }
      } catch (error) {
        reject(error)
      }
    })
  },

  /**
   * 社区运营者分享店铺
   * @param {*} param0
   * @param {obj: 分享字段JSON} param1
   */
  operatorShareProduct ({ commit, dispatch, state }, obj) {
    return new Promise((resolve, reject) => {
      try {
        const productInfo = JSON.stringify(obj)
        if (window.RFBridge) {
          window.RFBridge.RFN_OperatorShareProduct(productInfo)
          resolve()
        } else {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_OperatorShareProduct(productInfo)
            resolve()
          }, 1000)
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  /**
   * 社区运营者分享店铺
   * @param {*} param0
   * @param {obj: 分享字段JSON} param1
   */
  operatorShareShop ({ commit, dispatch, state }, obj) {
    return new Promise((resolve, reject) => {
      try {
        const shopInfo = JSON.stringify(obj)
        if (window.RFBridge) {
          window.RFBridge.RFN_OperatorShareShop(shopInfo)
          resolve()
        } else {
          let timer = setTimeout(function () {
            clearTimeout(timer)
            window.RFBridge.RFN_OperatorShareShop(shopInfo)
            resolve()
          }, 1000)
        }
      } catch (error) {
        reject(error)
      }
    })
  },

  /**
   * 跳转管家绑定钱包
   * @param {*} param0
   */
  openOperatorReg ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      try {
        window.RFBridge.RFN_OpenOperatorReg()
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },

  /**
   * 初始化微信分享
   * @param {*} param0
   * @param {*} param1
   */
  initWxShare ({ commit, dispatch, state }, { debug = false, appId, timestamp, nonceStr, signature } = {}) {
    let apiAction = 'initWxShare'
    commit(types.SET_API_TOGGLE_LOADING, { apiAction })
    return new Promise((resolve, reject) => {
      $wx.config({
        debug,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'translateVoice',
          'startRecord',
          'stopRecord',
          'onVoiceRecordEnd',
          'playVoice',
          'onVoicePlayEnd',
          'pauseVoice',
          'stopVoice',
          'uploadVoice',
          'downloadVoice',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'downloadImage',
          'getNetworkType',
          'openLocation',
          'getLocation',
          'hideOptionMenu',
          'showOptionMenu',
          'closeWindow',
          'scanQRCode',
          'chooseWXPay',
          'openProductSpecificView',
          'addCard',
          'chooseCard',
          'openCard',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'getLocalImgData'
        ]
      })
      $wx.ready(() => {
        dispatch('setSdkData', { isWxReady: true })
        commit(types.SET_API_TOGGLE_SUCCESS, { apiAction })
        $wx.hideMenuItems({
          menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3, fix iphone 上微信的“复制链接”功能复制出来的是修改前的链接bug
        })
        resolve('wx ready')
        // $wx.checkJsApi({
        //   jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'chooseImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        //   success: function (res) {
        //     alert(JSON.stringify(res))
        //   // 以键值对的形式返回，可用的api值true，不可用为false
        //   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        //   }
        // })
      })
    })
  },
  /**
   * 更改微信分享内容
   * @param {*} param0
   * @param {*{ icon：分享小图, title：分享标题, desc：分享描述, desc_timeline：朋友圈分享描述, link：分享链接, event：渠道或事件 }} param1
   */
  changeWxShare ({ commit, dispatch, state }, { icon, title, desc, descTimeline, link, event, onSuccess }) {
    // return new Promise((resolve, reject) => {
    let shareData = {
      friendQQ: {
        info: {
          imgUrl: icon,
          link: link,
          title: title,
          desc: desc
        },
        callback: function (res) {
          // alert('friendQQ:' + JSON.stringify(res))
          window._hmt.push(['_trackEvent', '分享到朋友或QQ', 'success', 'weixin'])
        }
      },
      TimelineQzone: {
        info: {
          imgUrl: icon,
          link: link,
          title: title
        },
        callback: (res) => {
          // alert('TimelineQzone:' + JSON.stringify(res))
          window._hmt.push(['_trackEvent', '分享到朋友圈或QQ空间', 'success', 'weixin'])
        }
      },
      Default: {
        imgUrl: icon,
        link: link,
        title: title,
        desc: desc,
        success: function (res) {
          // 统计代码
          window._hmt.push(['_trackEvent', '微信分享', 'success', 'weixin'])
          // dispatch('afterShare', 'wechat_friend')
          onSuccess && onSuccess('wechat_friend')
        }
      },
      Timeline: {
        imgUrl: icon,
        link: link,
        title: descTimeline,
        success: function (res) {
          // 统计代码
          window.MtaH5.clickShare('wechat_moments')
          window.MtaH5.clickStat('wechat_moments')
          // dispatch('afterShare', 'wechat_moments')
          onSuccess && onSuccess('wechat_moments')
        }
      },
      QQ: {
        imgUrl: icon,
        link: link,
        title: title,
        desc: desc,
        success: function (res) {
          // 统计代码
          window.MtaH5.clickShare('qq')
          window.MtaH5.clickStat('qq')
          // dispatch('afterShare', 'qq')
          onSuccess && onSuccess('qq')
        }
      },
      Weibo: {
        imgUrl: icon,
        link: link,
        title: title,
        desc: desc,
        success: function (res) {
          // 统计代码
          window.MtaH5.clickShare('sina')
          window.MtaH5.clickStat('sina')
          // dispatch('afterShare', 'sina')
          onSuccess && onSuccess('sina')
        }
      },
      QZone: {
        imgUrl: icon,
        link: link,
        title: title,
        desc: desc,
        success: function (res) {
          // 统计代码
          window.MtaH5.clickShare('qzone')
          window.MtaH5.clickStat('qzone')
          // dispatch('afterShare', 'qzone')
          onSuccess && onSuccess('qzone')
        }
      }
    }
    $wx.onMenuShareAppMessage(shareData.Default)
    $wx.onMenuShareTimeline(shareData.Timeline)
    $wx.onMenuShareQQ(shareData.QQ)
    $wx.onMenuShareWeibo(shareData.Weibo)
    $wx.onMenuShareQZone(shareData.QZone)

    $wx.updateAppMessageShareData(shareData.friendQQ.info, shareData.friendQQ.callback)
    $wx.updateTimelineShareData(shareData.TimelineQzone.info, shareData.TimelineQzone.callback)
  }
}

// 将api中定义的apiActions制作成action
for (let i in apiActions) {
  let obj = {
    [i]: function ({ commit, dispatch, state }, { restfulParams = {}, params = {}, options = {} } = {}) {
      let apiAction = i
      return webService({ commit, dispatch, apiAction }, { restfulParams, params, apiOptions: options }).then((data) => {
        // console.log(data);
        return data
      }).catch((reason) => {
        throw reason
      })
    }
  }
  Object.assign(actions, obj)
}

// 调试
function getConnectUrl () {
  let buildType = process.env.VUE_APP_BUILD_TYPE
  if (buildType === 'development') {
    // return 'http://192.168.197.113:3000/'
    return 'https://zizai-life.test.thinkinpower.net/zizai/universal-login/'
  } else if (buildType === 'test') {
    return '/zizai/universal-login/'
  } else {
    return '/zizai/universal-login/'
  }
}

/**
 * 删除给定的url的hash中的某个参数
 * @param {*} url
 */
function deleteQueryFromUrlHash (url, queryName) {
  let urlObj = {}
  try {
    urlObj = new window.URL(url)
    if (urlObj.hash.indexOf('?') !== -1) {
      const hashArr = urlObj.hash.split('?')
      const queryArr = hashArr[1].split('&')
      const queryArrNew = queryArr.filter(query => !query.match(queryName))
      urlObj.hash = hashArr[0] + '?' + queryArrNew.join('&')
    }
  } catch (e) { }
  return urlObj.href || url
}

export default actions
